module.exports = __webpack_public_path__ + "img/background_1@2x.55754f77.png";